import LabeledSelect from "./LabeledSelect";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {tryGetProductCampaign} from "../../redux/slices/searchSlice";
import {ComponentError} from "../ComponentLoader";

const CampaignProductSelect = ({
                                 label, value, onChange, type, placeholder = "Search Campaigns",
                                 emptyMsg = "No data", extData, ...props
                               }) => {


  const dispatch = useDispatch();
  const {loading, error, data, init} = useSelector((state) => state.search[type]) ?? {};


  useEffect(() => {
    if (type && !loading && !error && !init)
      dispatch(tryGetProductCampaign({type}));

  }, [type, init, error, loading]);

  useEffect(() => {
    if (extData && init) {
      const campaign = data.find((d) => d.id.toString() === extData);
      // onChange(data.find((d) => d.id.toString() === extData));
      if(campaign){
        onChange(campaign);
      }
    }
  }, [init]);

  return (
    error ? <ComponentError errorMsg={error} className="p-4 mb-2"
                            retry={() => dispatch(tryGetProductCampaign({type}))}/> :
      <LabeledSelect label={label} value={value} getOptionLabel={(option) => option.name} options={data}
                     getOptionValue={(option) => option.id} placeholder={placeholder}
                     onChange={onChange} emptyMsg={emptyMsg} {...props} loading={loading}/>
  );
};

export default CampaignProductSelect;
